// extracted by mini-css-extract-plugin
module.exports = {"expand":"CollapseIcon_expand__2XkwG","close":"CollapseIcon_close__33UI6","open":"CollapseIcon_open__3Mf7k"};